// // Shop All Click
// document.querySelector('.shop_all')?.addEventListener('click', function () {

//     // Remove active class from all categories
//     // document.querySelectorAll('.category-icon-item').forEach(el => {
//     //     el.classList.remove('active');
//     // });

//     // Clear all Wizzy filters
//     const clearBtn = document.querySelector('.wizzy-filters-clear-all');

//     if (clearBtn) {
//         clearBtn.click();
//     }

//     // Scroll to products section
//     setTimeout(() => {
//         const productSection = document.querySelector('.wizzy-search-results-container'); // Update selector if needed

//         if (productSection) {
//             productSection.scrollIntoView({
//                 behavior: 'smooth',
//                 block: 'start'
//             });
//         }
//     }, 300);
// });


// // Category Click
// document.querySelectorAll('.category-icon-item').forEach(item => {
//     item.addEventListener('click', function () {

//         // Remove active class from all categories
//         document.querySelectorAll('.category-icon-item').forEach(el => {
//             el.classList.remove('active');
//         });

//         // Add active class to clicked category
//         this.classList.add('active');

//         const category = this.dataset.category.toLowerCase();

//         const activeFilter = document.querySelector(
//             '.wizzy-facet-list-item input[type="checkbox"]:checked'
//         );

//         if (
//             activeFilter &&
//             activeFilter.closest('.wizzy-facet-list-item')?.dataset.term
//                 ?.toLowerCase()
//                 .includes(category)
//         ) {
//             document.querySelector('.category-icons-wrapper')?.scrollIntoView({
//                 behavior: 'smooth',
//                 block: 'start'
//             });
//             return;
//         }

//         if (category === 'all') {
//             const clearBtn = document.querySelector('.wizzy-filters-clear-all');

//             if (clearBtn) {
//                 clearBtn.click();
//             }

//             setTimeout(() => {
//                 document.querySelector('.category-icons-wrapper')?.scrollIntoView({
//                     behavior: 'smooth',
//                     block: 'start'
//                 });
//             }, 300);

//             return;
//         }

//         // Remove currently selected filters
//         document.querySelectorAll(
//             '.wizzy-facet-list-item input[type="checkbox"]:checked'
//         ).forEach(checkbox => checkbox.click());

//         // Apply selected category filter
//         setTimeout(() => {
//             document.querySelectorAll('.wizzy-facet-list-item').forEach(filter => {
//                 const title = (filter.dataset.term || '').toLowerCase();
//                 const words = title.split(' ');

//                 if (words.includes(category)) {
//                     filter.querySelector('input[type="checkbox"]')?.click();
//                 }
//             });

//             // Scroll back to category icons
//             document.querySelector('.category-icons-wrapper')?.scrollIntoView({
//                 behavior: 'smooth',
//                 block: 'start'
//             });

//         }, 100);
//     });
// });

// // Shop All Click
// document.querySelector('.shop_all')?.addEventListener('click', function () {

//     // Clear all Wizzy filters
//     const clearBtn = document.querySelector('.wizzy-filters-clear-all');

//     if (clearBtn) {
//         clearBtn.click();
//     }

//     // Scroll to products section
//     setTimeout(() => {
//         const productSection = document.querySelector('.wizzy-search-results-container');

//         if (productSection) {
//             productSection.scrollIntoView({
//                 behavior: 'smooth',
//                 block: 'start'
//             });
//         }
//     }, 300);
// });


// // Category Click
// document.querySelectorAll('.category-icon-item').forEach(item => {
//     item.addEventListener('click', function () {

//         // Remove active class from all categories
//         document.querySelectorAll('.category-icon-item').forEach(el => {
//             el.classList.remove('active');
//         });

//         // Add active class to clicked category
//         this.classList.add('active');

//         const category = this.dataset.category.toLowerCase();

//         const activeFilter = document.querySelector(
//             '.wizzy-facet-list-item input[type="checkbox"]:checked'
//         );

//         // If same category is already selected, do nothing
//         if (
//             activeFilter &&
//             activeFilter.closest('.wizzy-facet-list-item')?.dataset.term
//                 ?.toLowerCase()
//                 .includes(category)
//         ) {
//             return;
//         }

//         // Handle "All" category
//         if (category === 'all') {
//             const clearBtn = document.querySelector('.wizzy-filters-clear-all');

//             if (clearBtn) {
//                 clearBtn.click();
//             }

//             return;
//         }

//         // Remove currently selected filters
//         document.querySelectorAll(
//             '.wizzy-facet-list-item input[type="checkbox"]:checked'
//         ).forEach(checkbox => checkbox.click());

//         // Apply selected category filter
//         setTimeout(() => {
//             document.querySelectorAll('.wizzy-facet-list-item').forEach(filter => {
//                 const title = (filter.dataset.term || '').toLowerCase();
//                 const words = title.split(' ');

//                 if (words.includes(category)) {
//                     filter.querySelector('input[type="checkbox"]')?.click();
//                 }
//             });
//         }, 100);
//     });
// });

// Shop All Click
document.querySelectorAll('.shop_all').forEach(function (shopAll) {
    shopAll.addEventListener('click', function () {

        console.log("Shop All Clicked");

        const clearBtn = document.querySelector('.wizzy-filters-clear-all');

        if (clearBtn) {
            console.log("Clearing all filters...");
            clearBtn.click();
        } else {
            console.warn("Clear All button not found");
        }

        setTimeout(() => {
            const productSection = document.querySelector('.wizzy-search-results-container');

            // if (productSection) {
            //     productSection.scrollIntoView({
            //         behavior: 'smooth',
            //         block: 'start'
            //     });
            // }
        }, 300);
    });
});


// Category Click
document.querySelectorAll('.not-new-arrivals .category-icon-item').forEach(item => {

    item.addEventListener('click', function () {

        console.clear();

        document.querySelectorAll('.category-icon-item').forEach(el => {
            el.classList.remove('active');
        });

        this.classList.add('active');

        const category = this.dataset.category.toLowerCase();

        console.log("====================================");
        console.log("Selected Category:", category);

        const categoryMap = {
            "modi jacket": [
                "Modi Jacket"
            ],
            "shirts": [
                "Office Wear Shirts",
                "Casual Shirts",
                "Party Wear Shirts",
                "Semi Casual Shirts"
            ],
            "jeans": [
                "Jeans"
            ],
            "t-shirts": [
                "Polo T-Shirts",
                "T-Shirts",
                "Winter T-Shirts",
                "Oversized T-Shirts"
            ],
            "trousers": [
                "Formal Trousers",
                "Club Wear Trousers",
                "Casual Trousers"
            ]
        };

        console.log("Expected Filters:", categoryMap[category]);

        // Remove selected filters
        document.querySelectorAll(
            '.wizzy-facet-list-item input[type="checkbox"]:checked'
        ).forEach(cb => {
            console.log("Removing:", cb);
            cb.click();
        });
        

        setTimeout(() => {

            console.log("--------- Available Wizzy Filters ---------");

            document.querySelectorAll('.wizzy-facet-list-item').forEach(filter => {

                console.log("Filter HTML:", filter);

                console.log("dataset.term:", filter.dataset.term);

                const title = (filter.dataset.term || "").trim();

                if (
                    categoryMap[category] &&
                    categoryMap[category].includes(title)
                ) {

                    console.log("MATCH FOUND:", title);

                    const checkbox = filter.querySelector('input[type="checkbox"]');

                    console.log("Checkbox:", checkbox);

                    if (checkbox) {
                        console.log("CLICKING:", title);
                        checkbox.click();
                    } else {
                        console.warn("Checkbox NOT FOUND:", title);
                    }

                } else {

                    console.log("NO MATCH:", title);

                }

            });

        }, 100);

        

    });

});

document.querySelectorAll('.new-arrivals-entire-collections .category-icon-item').forEach(item => {

    item.addEventListener('click', function () {

        console.clear();

        document.querySelectorAll('.category-icon-item').forEach(el => {
            el.classList.remove('active');
        });

        this.classList.add('active');

        const category = this.dataset.category.toLowerCase();

        console.log("====================================");
        console.log("Selected Category:", category);

        const categoryMap = {
            "modi jacket": [
                "Modi Jacket"
            ],
            "shirts": [
                "Office Wear Shirts"
            ],
            "jeans": [
                "Jeans"
            ],
            "t-shirts": [
                "Polo T-Shirts",
                "T-Shirts",
                "Winter T-Shirts",
                "Oversized T-Shirts"
            ],
            "trousers": [
                "Formal Trousers",
                "Club Wear Trousers"
            ]
        };

        console.log("Expected Filters:", categoryMap[category]);

        // Remove selected filters
        document.querySelectorAll(
            '.wizzy-facet-list-item input[type="checkbox"]:checked'
        ).forEach(cb => {
            console.log("Removing:", cb);
            cb.click();
        });
        

        setTimeout(() => {

            console.log("--------- Available Wizzy Filters ---------");

            document.querySelectorAll('.wizzy-facet-list-item').forEach(filter => {

                console.log("Filter HTML:", filter);

                console.log("dataset.term:", filter.dataset.term);

                const title = (filter.dataset.term || "").trim();

                if (
                    categoryMap[category] &&
                    categoryMap[category].includes(title)
                ) {

                    console.log("MATCH FOUND:", title);

                    const checkbox = filter.querySelector('input[type="checkbox"]');

                    console.log("Checkbox:", checkbox);

                    if (checkbox) {
                        console.log("CLICKING:", title);
                        checkbox.click();
                    } else {
                        console.warn("Checkbox NOT FOUND:", title);
                    }

                } else {

                    console.log("NO MATCH:", title);

                }

            });

        }, 100);

        

    });

});






